import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "./store";
import http from "app/requests/axiosInstance";
import { Schedule } from "./schedulesSlice";
import {shopTimeZoneFromShops, toCalendarDateParam} from "../utils/timezone";

export interface MonthlySchedulesSliceState {
  [employeeId: number]: {
    [date: string]: Schedule[];
  };
}

const initialState = {} as MonthlySchedulesSliceState;

export const getMonthlySchedules = createAsyncThunk(
  "schedules/getMonthlySchedules",
  async (
    { employeeId, date }: { employeeId?: number; date: Date },
    thunkAPI
  ) => {
    try {
      const timezone = shopTimeZoneFromShops((thunkAPI.getState() as RootState).shops);
      const { data } = await http.get("/v1/schedules/monthly", {
        params: {
          schedules: {
            employeeId,
            date: toCalendarDateParam(date),
          },
          timezone,
          snakeCase: true,
        },
      });
      return { employeeId, data };
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

// export const createWeeklySchedules = createAsyncThunk(
// );

// export const updateWeeklySchedules = createAsyncThunk(
// );

// export const deleteWeeklySchedules = createAsyncThunk(
// );

export const monthlySchedulesSlice = createSlice({
  name: "monthlySchedules",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getMonthlySchedules.fulfilled, (state, action) => {
      const { employeeId, data } = action.payload as any;
      if (data.length > 0) {
        if (!state[employeeId]) {
          state[employeeId] = {};
        }
        data.forEach((schedule: Schedule) => {
          const date = schedule.date;

          if (!state[employeeId][date]) {
            state[employeeId][date] = [];
          }
          state[employeeId][date] = [schedule];
        });
      }
    });
  },
});

export const selectMonthlySchedules = (state: RootState) =>
  state.monthlySchedules;
